export const addPosts = (list) => {
  const blogList = document.querySelector('[data-home-blog-list]');

  if (blogList)
    blogList.appendChild(list)
}